export const APP_TOKEN_KEY = "token";
export const APP_USER_ID_KEY = "user";
export const APP_LOCAL_STORAGE_ACCOUNTS = "accounts";
export const APP_LOCAL_STORAGE_USER_DATA = "user-data";
